/* NO販売店情報(一覧) */
import React, { useState, memo } from 'react';
import { Grid, _ } from 'gridjs-react';
import { no_store_list_index } from '../Const';
var NoStoreList = function (_a) {
    var no_stores = _a.no_stores;
    var rows = useState(10)[0];
    return (React.createElement(Grid, { data: no_stores, columns: [
            {
                id: 'id',
                name: 'ID',
                hidden: true,
            },
            {
                id: 'parent_cd',
                name: 'NOコード',
                hidden: true,
            },
            {
                id: 'no_supervision',
                name: 'NO統括',
                width: '60px',
            },
            {
                id: 'd_code',
                name: 'D-Code',
                hidden: true,
            },
            {
                id: 'd_code',
                name: 'D-Code',
                width: '110px',
                formatter: function (cell, row) {
                    return _(React.createElement("a", { className: "link-text", href: "" + location.origin + process.env.MIX_MOCK_URL + "/staff/no_store/update/" + row.cells[no_store_list_index.id].data }, "" + row.cells[no_store_list_index.d_code].data));
                },
            },
            {
                id: 'shop_factor',
                name: 'GSB',
                width: '40px',
                formatter: function (cell) { var _a; return ((_a = String(cell)) === null || _a === void 0 ? void 0 : _a.includes('GSB')) ? '●' : ''; }
            },
            {
                id: 'shop_factor',
                name: 'GSS',
                width: '40px',
                formatter: function (cell) { var _a; return ((_a = String(cell)) === null || _a === void 0 ? void 0 : _a.includes('GSS')) ? '●' : ''; }
            },
            {
                id: 'shop_factor',
                name: 'GSMS',
                width: '40px',
                formatter: function (cell) { var _a; return ((_a = String(cell)) === null || _a === void 0 ? void 0 : _a.includes('GSMS')) ? '●' : ''; }
            },
            {
                id: 'shop_factor',
                name: 'Others',
                width: '60px',
                formatter: function (cell) { var _a; return ((_a = String(cell)) === null || _a === void 0 ? void 0 : _a.includes('Others')) ? '●' : ''; }
            },
            {
                id: 'shop_cd',
                name: '販売店コード',
                width: '100px',
            },
            {
                id: 'shop_name',
                name: '販売店名',
                width: '200px',
            },
            {
                id: 'country',
                name: '国',
                width: '120px',
            },
            {
                id: 'shop_city',
                name: '都市',
                width: '120px',
            },
        ], fixedHeader: true, height: "600px" }));
};
export default memo(NoStoreList);
